<script setup lang="ts">
type Props = {
  length: number
  activeIndex: number
}

defineProps<Props>()
</script>

<template>
  <div class="app-slider-dots">
    <div
      v-for="index in length"
      :key="index"
      class="app-slider-dots__item"
      :class="{ 'app-slider-dots__item--active': activeIndex === index - 1 }"
    />
  </div>
</template>

<style lang="scss" scoped>
.app-slider-dots {
  display: flex;
  gap: 4px;
  align-items: center;
  justify-content: center;

  &__item {
    flex-shrink: 0;
    width: 6px;
    height: 6px;
    background-color: rgba(var(--ui-dark-grey-rgb), 0.6);
    border-radius: 50%;
    transition: background-color 0.2s ease-in;

    &--active {
      background-color: var(--ui-secondary);
    }
  }
}
</style>
